// import { useState, useEffect, useRef } from 'react';
// import { io } from 'socket.io-client';
// import { v4 as uuidv4 } from 'uuid';
// import SimplePeer from 'simple-peer';
// import VideoPlayer from './VideoPlayer';
// import Controls from './Controls';

// const App = () => {
//   const [roomId, setRoomId] = useState('');
//   const [link, setLink] = useState('');
//   const [userId] = useState(uuidv4());
//   const [peers, setPeers] = useState([]);
//   const [stream, setStream] = useState(null);
//   const [isMuted, setIsMuted] = useState(false);
//   const [isVideoOff, setIsVideoOff] = useState(false);
//   const socketRef = useRef(null);
//   const videoRef = useRef(null);
//   const peersRef = useRef([]);

//   useEffect(() => {
//     socketRef.current = io('http://localhost:5000', {
//       transports: ['websocket'],
//       reconnection: true,
//     });

//     socketRef.current.on('connect', () => {
//       console.log('Connected to Socket.IO server');
//     });

//     socketRef.current.on('connect_error', (err) => {
//       console.error('Socket.IO connection error:', err);
//       alert('Failed to connect to server. Please check if the backend is running.');
//     });

//     navigator.mediaDevices
//       .getUserMedia({ video: true, audio: true })
//       .then((userStream) => {
//         setStream(userStream);
//         if (videoRef.current) {
//           videoRef.current.srcObject = userStream;
//         }
//       })
//       .catch((err) => {
//         console.error('Error accessing media devices:', err);
//         alert('Failed to access camera/microphone. Please grant permissions.');
//       });

//     const urlParams = new URLSearchParams(window.location.search);
//     const roomIdFromUrl = urlParams.get('roomId');
//     if (roomIdFromUrl) {
//       console.log(`Joining room from URL: ${roomIdFromUrl}`);
//       setRoomId(roomIdFromUrl);
//       setLink(`http://localhost:3000/?roomId=${roomIdFromUrl}`);
//       joinRoom(roomIdFromUrl);
//     }

//     return () => {
//       cleanup();
//     };
//   }, []);

//   const cleanup = () => {
//     console.log('Cleaning up resources');
//     if (stream) {
//       stream.getTracks().forEach((track) => track.stop());
//     }
//     peersRef.current.forEach(({ peer }) => peer.destroy());
//     peersRef.current = [];
//     setPeers([]);
//     setStream(null);
//     setRoomId('');
//     setLink('');
//     socketRef.current.disconnect();
//     socketRef.current = io('http://localhost:5000', {
//       transports: ['websocket'],
//       reconnection: true,
//     });
//   };

//   const createRoom = async () => {
//     try {
//       const response = await fetch('http://localhost:5000/api/room', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//       });
//       const data = await response.json();
//       if (data.roomId) {
//         console.log(`Created room: ${data.roomId}`);
//         setRoomId(data.roomId);
//         setLink(data.link);
//         joinRoom(data.roomId);
//       }
//     } catch (error) {
//       console.error('Error creating room:', error);
//       alert('Failed to create room.');
//     }
//   };

//   const joinRoom = (roomIdToJoin) => {
//     console.log(`Joining room: ${roomIdToJoin}`);
//     socketRef.current.emit('join-room', { roomId: roomIdToJoin, userId });

//     socketRef.current.on('user-connected', (newUserId) => {
//       if (newUserId !== userId) {
//         console.log(`New user connected: ${newUserId}`);
//         const peer = createPeer(newUserId, roomIdToJoin);
//         peersRef.current.push({ peerId: newUserId, peer });
//         setPeers((prev) => [...prev, { peerId: newUserId, peer, stream: null }]);
//       }
//     });

//     socketRef.current.on('user-disconnected', (disconnectedUserId) => {
//       console.log(`User disconnected: ${disconnectedUserId}`);
//       setPeers((prev) => prev.filter((p) => p.peerId !== disconnectedUserId));
//       peersRef.current = peersRef.current.filter((p) => p.peerId !== disconnectedUserId);
//     });

//     socketRef.current.on('signal', ({ signal, from }) => {
//       console.log(`Received signal from ${from}`);
//       const peerObj = peersRef.current.find((p) => p.peerId === from);
//       if (peerObj) {
//         peerObj.peer.signal(signal);
//       } else {
//         const peer = addPeer(signal, from, roomIdToJoin);
//         peersRef.current.push({ peerId: from, peer });
//         setPeers((prev) => [...prev, { peerId: from, peer, stream: null }]);
//       }
//     });

//     socketRef.current.on('end-call', () => {
//       console.log('End call received');
//       cleanup();
//       window.history.replaceState({}, document.title, '/');
//     });
//   };

//   const createPeer = (newUserId, roomId) => {
//     const peer = new SimplePeer({
//       initiator: true,
//       trickle: false,
//       stream,
//       config: {
//         iceServers: [
//           { urls: 'stun:stun.l.google.com:19302' },
//           { urls: 'stun:stun1.l.google.com:19302' },
//         ],
//       },
//     });

//     peer.on('signal', (signal) => {
//       console.log(`Sending signal to ${newUserId}`);
//       socketRef.current.emit('signal', { signal, to: newUserId, from: userId, roomId });
//     });

//     peer.on('stream', (remoteStream) => {
//       console.log(`Received stream from ${newUserId}`);
//       setPeers((prev) =>
//         prev.map((p) =>
//           p.peerId === newUserId ? { ...p, stream: remoteStream } : p
//         )
//       );
//     });

//     peer.on('error', (err) => {
//       console.error('Peer error:', err);
//     });

//     return peer;
//   };

//   const addPeer = (signal, callerId, roomId) => {
//     const peer = new SimplePeer({
//       initiator: false,
//       trickle: false,
//       stream,
//       config: {
//         iceServers: [
//           { urls: 'stun:stun.l.google.com:19302' },
//           { urls: 'stun:stun1.l.google.com:19302' },
//         ],
//       },
//     });

//     peer.on('signal', (data) => {
//       console.log(`Sending signal to ${callerId}`);
//       socketRef.current.emit('signal', { signal: data, to: callerId, from: userId, roomId });
//     });

//     peer.on('stream', (remoteStream) => {
//       console.log(`Received stream from ${callerId}`);
//       setPeers((prev) =>
//         prev.map((p) =>
//           p.peerId === callerId ? { ...p, stream: remoteStream } : p
//         )
//       );
//     });

//     peer.on('error', (err) => {
//       console.error('Peer error:', err);
//     });

//     peer.signal(signal);
//     return peer;
//   };

//   const toggleMute = () => {
//     if (stream) {
//       stream.getAudioTracks().forEach((track) => {
//         track.enabled = !track.enabled;
//       });
//       setIsMuted(!isMuted);
//     }
//   };

//   const toggleVideo = () => {
//     if (stream) {
//       stream.getVideoTracks().forEach((track) => {
//         track.enabled = !track.enabled;
//       });
//       setIsVideoOff(!isVideoOff);
//     }
//   };

//   const endCall = () => {
//     console.log('Ending call');
//     socketRef.current.emit('end-call', { roomId });
//     cleanup();
//     window.history.replaceState({}, document.title, '/');
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 flex flex-col items-center p-4">
//       <h1 className="text-3xl font-bold mb-6">Video Call App</h1>
//       {!roomId ? (
//         <button
//           onClick={createRoom}
//           className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
//         >
//           Start a New Call
//         </button>
//       ) : (
//         <div className="w-full max-w-md">
//           <p className="mb-4">
//             Share this link to invite others:{' '}
//             <a href={link} className="text-blue-500 underline">
//               {link}
//             </a>
//           </p>
//           <div className="flex flex-col items-center">
//             {stream ? (
//               <VideoPlayer stream={stream} isLocal={true} videoRef={videoRef} />
//             ) : (
//               <p>Loading local stream...</p>
//             )}
//             <Controls
//               isMuted={isMuted}
//               isVideoOff={isVideoOff}
//               toggleMute={toggleMute}
//               toggleVideo={toggleVideo}
//               endCall={endCall}
//             />
//             <div className="grid grid-cols-1 gap-4">
//               {peers.map(({ peerId, stream: peerStream }) =>
//                 peerStream ? (
//                   <VideoPlayer key={peerId} stream={peerStream} isLocal={false} />
//                 ) : (
//                   <p key={peerId}>Waiting for remote stream...</p>
//                 )
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default App;

import { useState, useEffect, useRef } from "react";
import { io } from "socket.io-client";
import { v4 as uuidv4 } from "uuid";
import SimplePeer from "simple-peer";
import VideoPlayer from "./VideoPlayer";
import Controls from "./Controls";

const SOCKET_SERVER_URL = "https://api-ejob.edrive.ng";

// const SOCKET_SERVER_URL = "http://localhost:5000";

const App = () => {
  const [roomId, setRoomId] = useState("");
  const [link, setLink] = useState("");
  const [userId] = useState(uuidv4());
  const [peers, setPeers] = useState([]);
  const [stream, setStream] = useState(null);
  const [isMuted, setIsMuted] = useState(false);
  const [isVideoOff, setIsVideoOff] = useState(false);
  const socketRef = useRef(null);
  const videoRef = useRef(null);
  const peersRef = useRef([]);

  useEffect(() => {
    socketRef.current = io(SOCKET_SERVER_URL, {
      transports: ["websocket"],
      reconnection: true,
      forceNew: true,
    });

    socketRef.current.on("connect", () => {
      console.log("Connected to Socket.IO server, id:", socketRef.current.id);
    });

    socketRef.current.on("connect_error", (err) => {
      console.error("Socket.IO connection error:", err);
      alert(
        "Failed to connect to server. Please check if the backend is running."
      );
    });

    socketRef.current.on("room-full", () => {
      console.log("Room is full");
      alert("Room is full. Please try a different room.");
      cleanup();
      window.history.replaceState({}, document.title, "/");
    });

    navigator.mediaDevices
      .getUserMedia({ video: { width: 640, height: 480 }, audio: true })
      .then((userStream) => {
        console.log("Local stream acquired");
        setStream(userStream);
        if (videoRef.current) {
          videoRef.current.srcObject = userStream;
        }
      })
      .catch((err) => {
        console.error("Error accessing media devices:", err);
        alert("Failed to access camera/microphone. Please grant permissions.");
      });

    const urlParams = new URLSearchParams(window.location.search);
    const roomIdFromUrl = urlParams.get("roomId");
    if (roomIdFromUrl) {
      console.log(`Joining room from URL: ${roomIdFromUrl}`);
      setRoomId(roomIdFromUrl);
      setLink(`${window.location.origin}/?roomId=${roomIdFromUrl}`);
      joinRoom(roomIdFromUrl);
    }

    return () => {
      cleanup();
    };
  }, []);

  const cleanup = () => {
    console.log("Cleaning up resources");
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }
    peersRef.current.forEach(({ peer }) => peer.destroy());
    peersRef.current = [];
    setPeers([]);
    setStream(null);
    setRoomId("");
    setLink("");
    if (socketRef.current) {
      socketRef.current.emit("end-call", { roomId });
      socketRef.current.disconnect();
      socketRef.current = null;
    }
  };

  const createRoom = async () => {
    try {
      const response = await fetch("https://api-ejob.edrive.ng/api/room", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      const data = await response.json();
      if (data.roomId) {
        console.log(`Created room: ${data.roomId}`);
        setRoomId(data.roomId);
        setLink(data.link);
        joinRoom(data.roomId);
      }
    } catch (error) {
      console.error("Error creating room:", error);
      alert("Failed to create room.");
    }
  };

  const joinRoom = (roomIdToJoin) => {
    console.log(`Joining room: ${roomIdToJoin} as user: ${userId}`);
    socketRef.current.emit("join-room", { roomId: roomIdToJoin, userId });
    console.log("Emitted join-room event");

    socketRef.current.on("user-connected", (newUserId) => {
      if (newUserId !== userId) {
        console.log(`New user connected: ${newUserId}`);
        if (stream) {
          const peer = createPeer(newUserId, roomIdToJoin);
          peersRef.current.push({ peerId: newUserId, peer });
          setPeers((prev) => [
            ...prev,
            { peerId: newUserId, peer, stream: null },
          ]);
        } else {
          console.warn("Local stream not ready, delaying peer creation");
          socketRef.current.once("stream-ready", () => {
            const peer = createPeer(newUserId, roomIdToJoin);
            peersRef.current.push({ peerId: newUserId, peer });
            setPeers((prev) => [
              ...prev,
              { peerId: newUserId, peer, stream: null },
            ]);
          });
        }
      }
    });

    socketRef.current.on("user-disconnected", (disconnectedUserId) => {
      console.log(`User disconnected: ${disconnectedUserId}`);
      setPeers((prev) => prev.filter((p) => p.peerId !== disconnectedUserId));
      peersRef.current = peersRef.current.filter(
        (p) => p.peerId !== disconnectedUserId
      );
    });

    socketRef.current.on(
      "signal",
      ({ signal, from, roomId: receivedRoomId }) => {
        console.log(`Received signal from ${from} for room ${receivedRoomId}`);
        if (receivedRoomId !== roomIdToJoin) {
          console.warn(
            `Signal for wrong room: ${receivedRoomId}, expected: ${roomIdToJoin}`
          );
          return;
        }
        const peerObj = peersRef.current.find((p) => p.peerId === from);
        if (peerObj) {
          console.log(`Signaling existing peer ${from}`);
          peerObj.peer.signal(signal);
        } else {
          console.log(`Creating new peer for ${from}`);
          const peer = addPeer(signal, from, roomIdToJoin);
          peersRef.current.push({ peerId: from, peer });
          setPeers((prev) => [...prev, { peerId: from, peer, stream: null }]);
        }
      }
    );

    socketRef.current.on("end-call", () => {
      console.log("End call received");
      cleanup();
      window.history.replaceState({}, document.title, "/");
    });

    if (stream) {
      socketRef.current.emit("stream-ready", { roomId: roomIdToJoin });
    } else {
      const streamListener = () => {
        socketRef.current.emit("stream-ready", { roomId: roomIdToJoin });
      };
      socketRef.current.once("stream-ready", streamListener);
    }
  };

  const createPeer = (newUserId, roomId) => {
    console.log(`Creating initiator peer for ${newUserId}`);
    const peer = new SimplePeer({
      initiator: true,
      trickle: true, // Enable trickle ICE for better connectivity
      stream,
      config: {
        iceServers: [
          { urls: "stun:stun.l.google.com:19302" },
          { urls: "stun:stun1.l.google.com:19302" },
          // Add a TURN server for production
          // {
          //   urls: 'turn:your-turn-server.com',
          //   username: 'your-username',
          //   credential: 'your-credential'
          // }
        ],
      },
    });

    peer.on("signal", (signal) => {
      console.log(`Sending signal to ${newUserId} for room ${roomId}`);
      socketRef.current.emit("signal", {
        signal,
        to: newUserId,
        from: userId,
        roomId,
      });
    });

    peer.on("stream", (remoteStream) => {
      console.log(`Received stream from ${newUserId}`);
      setPeers((prev) =>
        prev.map((p) =>
          p.peerId === newUserId ? { ...p, stream: remoteStream } : p
        )
      );
    });

    peer.on("connect", () => {
      console.log(`Peer connected with ${newUserId}`);
    });

    peer.on("error", (err) => {
      console.error(`Peer error with ${newUserId}:`, err);
    });

    peer.on("close", () => {
      console.log(`Peer closed with ${newUserId}`);
      setPeers((prev) => prev.filter((p) => p.peerId !== newUserId));
      peersRef.current = peersRef.current.filter((p) => p.peerId !== newUserId);
    });

    return peer;
  };

  const addPeer = (signal, callerId, roomId) => {
    console.log(`Creating non-initiator peer for ${callerId}`);
    const peer = new SimplePeer({
      initiator: false,
      trickle: true, // Enable trickle ICE
      stream,
      config: {
        iceServers: [
          { urls: "stun:stun.l.google.com:19302" },
          { urls: "stun:stun1.l.google.com:19302" },
        ],
      },
    });

    peer.on("signal", (data) => {
      console.log(`Sending signal to ${callerId} for room ${roomId}`);
      socketRef.current.emit("signal", {
        signal: data,
        to: callerId,
        from: userId,
        roomId,
      });
    });

    peer.on("stream", (remoteStream) => {
      console.log(`Received stream from ${callerId}`);
      setPeers((prev) =>
        prev.map((p) =>
          p.peerId === callerId ? { ...p, stream: remoteStream } : p
        )
      );
    });

    peer.on("connect", () => {
      console.log(`Peer connected with ${callerId}`);
    });

    peer.on("error", (err) => {
      console.error(`Peer error with ${callerId}:`, err);
    });

    peer.on("close", () => {
      console.log(`Peer closed with ${callerId}`);
      setPeers((prev) => prev.filter((p) => p.peerId !== callerId));
      peersRef.current = peersRef.current.filter((p) => p.peerId !== callerId);
    });

    peer.signal(signal);
    return peer;
  };

  const toggleMute = () => {
    if (stream) {
      stream.getAudioTracks().forEach((track) => {
        track.enabled = !track.enabled;
      });
      setIsMuted(!isMuted);
    }
  };

  const toggleVideo = () => {
    if (stream) {
      stream.getVideoTracks().forEach((track) => {
        track.enabled = !track.enabled;
      });
      setIsVideoOff(!isVideoOff);
    }
  };

  const endCall = () => {
    console.log("Ending call");
    socketRef.current.emit("end-call", { roomId });
    cleanup();
    window.history.replaceState({}, document.title, "/");
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center p-4">
      <h1 className="text-3xl font-bold mb-6">Video Call App</h1>
      {!roomId ? (
        <button
          onClick={createRoom}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Start a New Call
        </button>
      ) : (
        <div className="w-full max-w-md">
          <p className="mb-4">
            Share this link to invite others:{" "}
            <a href={link} className="text-blue-500 underline">
              {link}
            </a>
          </p>
          <div className="flex flex-col items-center">
            {stream ? (
              <VideoPlayer stream={stream} isLocal={true} videoRef={videoRef} />
            ) : (
              <p>Loading local stream...</p>
            )}
            <Controls
              isMuted={isMuted}
              isVideoOff={isVideoOff}
              toggleMute={toggleMute}
              toggleVideo={toggleVideo}
              endCall={endCall}
            />
            <div className="grid grid-cols-1 gap-4">
              {peers.map(({ peerId, stream: peerStream }) =>
                peerStream ? (
                  <VideoPlayer
                    key={peerId}
                    stream={peerStream}
                    isLocal={false}
                  />
                ) : (
                  <p key={peerId}>Waiting for remote stream...</p>
                )
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default App;

// import React from 'react';
// import VideoCall from './VideoCall';

// import './index.css';

// function App() {
//   return (
//     <div className="min-h-screen bg-gray-100 flex items-center justify-center">
//       <VideoCall />
//     </div>
//   );
// }

// export default App;
